import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import { environment } from '../../../environments/environment';
import { NotificationDetailDTO } from '../../models/notification-center/notificationDetail.model';
import { TranslateService } from '@ngx-translate/core';
import { NotificationParameterDTO } from '../../models/notification-center/notification-parameter.model';

@Injectable({ providedIn: 'root' })

export class NotificationService {

    constructor(
        private http: HttpClient,
        private translate: TranslateService,
    ) { }

    getNotifications(onlyUnread: boolean): Promise<Array<NotificationDetailDTO>> {
        return this.http.get<Array<NotificationDetailDTO>>(environment.apiFullUrl + '/Notification/GetNotifications/' + onlyUnread).toPromise();
    }

    markAsRead(id: number): Promise<Date> {
        return this.http.get<Date>(environment.apiFullUrl + '/Notification/MarkAsRead/' + id).toPromise();
    }

    markListAsRead(IDs: number[]): Promise<any> {
        return this.http.post<any>(environment.apiFullUrl + '/Notification/MarkListAsRead', IDs).toPromise();
    }

    createNotification(dto: NotificationParameterDTO): Promise<any> {
      return this.http.post<any>(environment.apiFullUrl + '/Notification/CreateNotification', dto).toPromise();
    }

    deleteNotification(id: number): Promise<any> {
      return this.http.delete<any>(environment.apiFullUrl + '/Notification/' + id).toPromise();
    }
}
